import { render } from "./BaseNftCard.vue?vue&type=template&id=6a413d2e&scoped=true"
import script from "./BaseNftCard.vue?vue&type=script&lang=js"
export * from "./BaseNftCard.vue?vue&type=script&lang=js"

import "./BaseNftCard.vue?vue&type=style&index=0&id=6a413d2e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6a413d2e"

export default script